import React from 'react';
import { Link } from 'react-router-dom';
import { Table } from 'semantic-ui-react';

import { escribirMonto } from '../../utilidades';
import { Columna, DatosApoderado } from '../tipos';

interface Props {
    columnaAOrdenar: Columna;
    direccionDelOrden: 'ascending' | 'descending';
    datos: ReadonlyArray<Readonly<DatosApoderado>>;
    alClickearCabecera(columna: Columna): void;
}

type FilaProps = DatosApoderado;

const nombresFormasPago: Record<DatosApoderado['tipoDeFormaDePago'], string> = {
    contado: 'Contado',
    tarjeta: 'Tarjeta',
    cheque: 'Cheque',
    pagare: 'Pagaré',
};

function escribirFecha(fecha: string) {
    const [año, mes, dia] = fecha.split('-');
    return `${dia}-${mes}-${año}`;
}

class Fila extends React.PureComponent<FilaProps> {
    public render() {
        const {
            id,
            nombreCompleto,
            tipoDeFormaDePago,
            cuotasAtrasadas,
            fechaDelUltimoPagoRealizado,
            paraElAño,
        } = this.props;

        const fecha =
            fechaDelUltimoPagoRealizado !== ''
                ? escribirFecha(fechaDelUltimoPagoRealizado)
                : 'nunca';

        const [primeraCuota, ...resto] = cuotasAtrasadas;
        const cantidadDeCuotas = cuotasAtrasadas.length;
        return (
            <React.Fragment>
                <Table.Row>
                    <Table.Cell selectable rowSpan={cantidadDeCuotas}>
                        <Link to={`/cobranzas/plan/${id}`}>
                            <b>{nombreCompleto}</b>
                        </Link>
                    </Table.Cell>

                    <Table.Cell rowSpan={cantidadDeCuotas} textAlign='center'>
                        {fecha}
                    </Table.Cell>

                    <Table.Cell rowSpan={cantidadDeCuotas} textAlign='center'>
                        {nombresFormasPago[tipoDeFormaDePago]}
                    </Table.Cell>

                    <Table.Cell rowSpan={cantidadDeCuotas} textAlign='center'>
                        {paraElAño}
                    </Table.Cell>

                    {this.renderizarFilasDeCuota(primeraCuota)}
                </Table.Row>
                {cantidadDeCuotas > 1 &&
                    resto.map(cuota => (
                        <Table.Row key={`${id}${cuota.numeroDeCuota}`}>
                            {this.renderizarFilasDeCuota(cuota)}
                        </Table.Row>
                    ))}
            </React.Fragment>
        );
    }

    private renderizarFilasDeCuota(cuota: FilaProps['cuotasAtrasadas'][number]) {
        return (
            <React.Fragment>
                <Table.Cell textAlign='center'>{cuota.numeroDeCuota}</Table.Cell>
                <Table.Cell textAlign='center'>
                    {escribirFecha(cuota.fechaDeVencimiento)}
                </Table.Cell>
                <Table.Cell textAlign='center'>{cuota.diasDeAtraso} días</Table.Cell>
                <Table.Cell textAlign='center'>{escribirMonto(cuota.montoDeLaDeuda)}</Table.Cell>
            </React.Fragment>
        );
    }
}

const TablaDeDeudores: React.FunctionComponent<Props> = props => {
    const { datos, columnaAOrdenar, direccionDelOrden, alClickearCabecera } = props;

    const propsOrdenamiento = (columna: Columna) => ({
        sorted: columnaAOrdenar === columna ? direccionDelOrden : undefined,
        onClick: () => alClickearCabecera(columna),
    });

    return (
        <Table celled structured sortable attached='bottom'>
            <Table.Header>
                <Table.Row>
                    <Table.HeaderCell
                        width='6'
                        rowSpan='2'
                        content='Nombre'
                        {...propsOrdenamiento('nombreCompleto')}
                    />

                    <Table.HeaderCell
                        width='2'
                        rowSpan='2'
                        content='Fecha del últmo pago'
                        {...propsOrdenamiento('fechaDelUltimoPagoRealizado')}
                    />

                    <Table.HeaderCell
                        width='1'
                        rowSpan='2'
                        content='Forma de pago'
                        {...propsOrdenamiento('tipoDeFormaDePago')}
                    />

                    <Table.HeaderCell
                        width='1'
                        rowSpan='2'
                        content='Año'
                        {...propsOrdenamiento('paraElAño')}
                    />

                    <Table.HeaderCell
                        width='6'
                        colSpan='4'
                        textAlign='center'
                        content='Cuotas atrasadas'
                    />
                </Table.Row>
                <Table.Row>
                    <Table.HeaderCell
                        content='Número'
                        textAlign='center'
                        {...propsOrdenamiento('numeroDeCuota')}
                    />
                    <Table.HeaderCell
                        content='Vencimiento'
                        textAlign='center'
                        {...propsOrdenamiento('fechaDeVencimiento')}
                    />
                    <Table.HeaderCell
                        content='Atraso'
                        textAlign='center'
                        {...propsOrdenamiento('diasDeAtraso')}
                    />
                    <Table.HeaderCell
                        content='Monto'
                        textAlign='center'
                        {...propsOrdenamiento('montoDeLaDeuda')}
                    />
                </Table.Row>
            </Table.Header>

            <Table.Body>
                {datos.map(fila => (
                    <Fila key={fila.id} {...fila} />
                ))}
            </Table.Body>
        </Table>
    );
};

export default TablaDeDeudores;



// WEBPACK FOOTER //
// ./src/modulos/Cobranzas/componentes/Deudores/componentes/TablaDeDeudores.tsx